"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IPublishingStage = void 0;
var IPublishingStage;
(function (IPublishingStage) {
    IPublishingStage["Draft"] = "Draft";
    IPublishingStage["Pending"] = "Pending";
    IPublishingStage["Private"] = "Private";
    IPublishingStage["Published"] = "Published";
    IPublishingStage["Restricted"] = "Restricted";
    IPublishingStage["Unlisted"] = "Unlisted";
})(IPublishingStage || (exports.IPublishingStage = IPublishingStage = {}));
//# sourceMappingURL=publishing-stage.js.map